export enum OpinionItemType {
  NS = 'NS', // Narrative Stickiness - 밈의 본질적 강력함
  ME = 'ME', // Meme Expandability - 재점화, viral 가능성
  AQ = 'AQ', // Attention Quality - 현재 관심도, 커뮤니티 활동 수준
  R = 'R',   // Risk - 부정적 요소 (감점)
}
